import React, { useEffect, useState } from 'react';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
// import { Column } from '@ant-design/plots';
import { Pie } from '@ant-design/plots';
import axios from 'axios';
import h2ologo from '../../../Components/NavBar/res/h2ologo.png'



const ProfitPercentage = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
      asyncFetch();
    }, []);

    
    const asyncFetch = () => {
        let apiURL = `${FetchVariable.Heroku}/sales/get-profit-by-make`
        axios.get(apiURL)
        .then(res=>{
            let data = res?.data
            let array=[]
            data.map((e)=>{
              return array?.push({Model: e.Model, Profit:parseInt(e.Profit)})
            })
            setData(array)
        })
    };
    // const config = {
    //   data,
    //   xField: 'Model',
    //   yField: 'Profit',
    //   xAxis: {
    //     label: {
    //       autoRotate: false,
    //     },
    //   },
    //   scrollbar: {
    //     type: 'horizontal',
    //   },
    // };
    const config = {
        appendPadding: 10,
        data,
        angleField: `Profit`,
        colorField: 'Model',
        radius: 0.8,
        innerRadius: 0.64,
        label: {
          type: 'inner',
          offset: '-50%',
          content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
          style: {
            fill: '#fff',
            fontSize: 14,
            textAlign: 'center',
          },
        },
        statistic: null,
        annotations: [
          {
            type: 'image',
            src: h2ologo,
            position: ['100%', '50%'],
            style: {
              width: 100,
              height: 100,
            },
            offsetX: -50,
            offsetY: 50,
          },
        ],
      };
  
    // return <Column {...config} />;
    return <Pie {...config}/>
  };

export default ProfitPercentage